import { forgetSessionState } from 'lib/helpers/sessionPersistedAtom';

/**
 * Drops every `myriad:` sessionStorage key. Every logout path navigates by SPA, so sessionStorage
 * survives into whoever signs in next in the same tab. The atoms holding that state are reset by
 * `useResetSessionOnAccountChange`.
 */
export const clearScopedSessionStorage = () => forgetSessionState('myriad');
